import { render } from "./ProductButtons.vue?vue&type=template&id=68774e17&lang=pug"
import script from "./ProductButtons.vue?vue&type=script&lang=js"
export * from "./ProductButtons.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__